import script from "./CheckboxField.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxField.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxField.vue?vue&type=style&index=0&id=e383efb2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e383efb2"]])

export default __exports__